// The HTML installs a queue immediately; its SDK is loaded after critical work.
// No PII is added to event payloads. Analytics must never block shopping.
const CURRENCY = 'INR';
const seen = new Set();
let visit = '';
let navigation = null;
let visitNumber = 0;

function send(name, data = {}, options) {
  try {
    if (typeof window.fbq !== 'function') return false;
    window.fbq('track', name, data, options);
    return true;
  } catch { return false; }
}

function once(name, key, data) {
  const id = `${visit}:${name}:${key}`;
  if (seen.has(id)) return;
  if (send(name, data)) seen.add(id);
}

export function trackPageView(path, key) {
  // React Router reuses a history entry's key on Back/Forward. Deduplicate
  // repeated effects for the current visit, not every lifetime visit to a key.
  const token = `${key || ''}:${path}`;
  if (navigation !== token) {
    navigation = token;
    visit = String(++visitNumber);
  }
  if (/^\/(admin(?:-portal)?|pos|account|login|register|auth|order|orders|balance-pay|r|reset-password|forgot-password)(\/|\?|$)/.test(path)) return;
  once('PageView', path, {});
}

export function trackViewContent(product) {
  if (!product?.id) return;
  once('ViewContent', product.id, {
    content_ids: [product.id], content_name: product.name, content_type: 'product',
    content_category: product.brand || '', value: Number(product.price) || 0, currency: CURRENCY,
  });
}

export function trackSearch(query) {
  const q = (query || '').trim();
  if (q) once('Search', q, { search_string: q });
}

export function trackAddToCart(product, qty) {
  if (!product?.id || qty <= 0) return;
  const price = Number(product.price) || 0;
  send('AddToCart', {
    content_ids: [product.id], content_name: product.name, content_type: 'product',
    content_category: product.brand || '', value: price * qty, currency: CURRENCY,
    contents: [{ id: product.id, quantity: qty, item_price: price }],
  });
}

function basket(items) {
  const list = (Array.isArray(items) ? items : []).filter(i => i && (i.product_id || i.id));
  return {
    content_ids: list.map(i => i.product_id || i.id), content_type: 'product', currency: CURRENCY,
    num_items: list.reduce((n, i) => n + Number(i.quantity || 1), 0),
    contents: list.map(i => ({ id: i.product_id || i.id, quantity: Number(i.quantity || 1), item_price: Number(i.price) || 0 })),
  };
}

export function trackInitiateCheckout(items) {
  if (!items?.length) return;
  const value = items.reduce((sum, i) => sum + (Number(i.price) || 0) * Number(i.quantity || 1), 0);
  once('InitiateCheckout', 'entry', { ...basket(items), value: Math.round(value * 100) / 100 });
}

export function trackPurchase(order) {
  if (!order?.order_number || order.payment_status !== 'paid') return;
  const eventID = `purchase_${order.order_number}`;
  const key = `ogmini_meta_${eventID}`;
  if (seen.has(key)) return;
  try { if (localStorage.getItem(key)) return; } catch { /* memory guard still works */ }
  const value = Number(order.amount_charged ?? order.total);
  if (!Number.isFinite(value) || value < 0) return;
  if (send('Purchase', { ...basket(order.items), value: Math.round(value * 100) / 100, order_id: order.order_number }, { eventID })) {
    seen.add(key);
    try { localStorage.setItem(key, String(Date.now())); } catch { /* non-fatal */ }
  }
}